module.exports = __webpack_public_path__ + "images/canonical-card/checklist-icon-complete.c2d9cae64cc0ecddaba6.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/checklist-icon-complete.svg
// module id = r/oR
// module chunks = 2